<template>
  <v-btn class="primary--text float-right" light large :to="{ name: pathTo }">
    <v-icon>{{ icone }}</v-icon
    >{{ descricao }}
  </v-btn>
</template>

<script>
export default {
  props: {
    pathTo: {
      type: String,
    },
    icone: {
      type: String,
    },
    descricao: {
      type: String,
    },
  },
}
</script>
